import { render, staticRenderFns } from "./Chatters.vue?vue&type=template&id=413c3532"
import script from "./Chatters.vue?vue&type=script&lang=js"
export * from "./Chatters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports